var render, staticRenderFns
import script from "./WikiContent.vue?vue&type=script&lang=js&"
export * from "./WikiContent.vue?vue&type=script&lang=js&"
import style0 from "./WikiContent.vue?vue&type=style&index=0&id=6adae452&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adae452",
  null
  
)

export default component.exports